import React, { useState } from 'react';
import { useAuth } from '../auth';
import api from '../api';
import './estilodashuser.css';

export default function ResetSenhaUser() {
  const { user } = useAuth();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const handleResetSenha = async () => {
    if (!novaSenha || !confirmarSenha) {
      setErro('Todos os campos são obrigatórios.');
      setMensagem('');
      return;
    }

    if (novaSenha !== confirmarSenha) {
      setErro('As senhas não coincidem.');
      setMensagem('');
      return;
    }

    if (novaSenha.length < 6) {
      setErro('A senha deve ter pelo menos 6 caracteres.');
      setMensagem('');
      return;
    }

    try {
      setSalvando(true);
      const response = await api.put(
        `/api/clientes/reset-senha/${user.id}`,
        { novaSenha }
      );

      setMensagem(response.data.message || 'Senha alterada com sucesso!');
      setErro('');
      setNovaSenha('');
      setConfirmarSenha('');
    } catch (error) {
      console.error('Erro ao resetar a senha:', error);

      const status = error.response?.status;
      if (status === 403) {
        setErro(
          'Seu servidor atual ainda não libera alteração de senha diretamente pelo cliente. Fale com o suporte para concluir a troca.'
        );
      } else {
        setErro(
          error.response?.data?.message ||
            'Erro ao alterar a senha. Tente novamente.'
        );
      }

      setMensagem('');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="content-page">
      <div className="content-card content-card-small">
        <div className="content-page-header">
          <div>
            <h2>Alterar Senha</h2>
            <p>
              Use esta área para manter sua conta segura. Escolha uma senha forte e evite reutilizar senhas antigas.
            </p>
          </div>
        </div>

        <div className="cliente-help-box" style={{ marginBottom: 14 }}>
          <strong>Recomendação:</strong> use uma senha com letras maiúsculas e minúsculas, números e, se possível, caracteres especiais.
        </div>

        <div className="reset-senha-form">
          <label htmlFor="novaSenha">Nova senha</label>
          <input
            type="password"
            id="novaSenha"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            placeholder="Digite sua nova senha"
          />

          <label htmlFor="confirmarSenha">Confirmar nova senha</label>
          <input
            type="password"
            id="confirmarSenha"
            value={confirmarSenha}
            onChange={(e) => setConfirmarSenha(e.target.value)}
            placeholder="Confirme sua nova senha"
          />

          <button
            onClick={handleResetSenha}
            className="btn-reset-senha"
            type="button"
            disabled={salvando}
          >
            {salvando ? 'Alterando...' : 'Alterar senha'}
          </button>
        </div>

        {erro && <p className="error-message">{erro}</p>}
        {mensagem && <p className="success-message">{mensagem}</p>}
      </div>
    </div>
  );
}
